/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update the before day settings
 * @export
 * @interface BeforeDayRequest
 */
export interface BeforeDayRequest {
    /**
     * the number of days before an appointment can be reserved
     * @type {number}
     * @memberof BeforeDayRequest
     */
    beforeDay?: number;
}

/**
 * Check if a given object implements the BeforeDayRequest interface.
 */
export function instanceOfBeforeDayRequest(value: object): value is BeforeDayRequest {
    return true;
}

export function BeforeDayRequestFromJSON(json: any): BeforeDayRequest {
    return BeforeDayRequestFromJSONTyped(json, false);
}

export function BeforeDayRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeforeDayRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'beforeDay': json['beforeDay'] == null ? undefined : json['beforeDay'],
    };
}

export function BeforeDayRequestToJSON(json: any): BeforeDayRequest {
    return BeforeDayRequestToJSONTyped(json, false);
}

export function BeforeDayRequestToJSONTyped(value?: BeforeDayRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'beforeDay': value['beforeDay'],
    };
}

